"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerContactPhone = void 0;
const common_1 = require("../../common");
class PartnerContactPhone extends common_1.MongoSubDocument {
}
exports.PartnerContactPhone = PartnerContactPhone;
//# sourceMappingURL=partner-contact-phone.model.js.map